var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CardModal } from "./CardList/Card";
import Button from "./Semantic/Button";
import { logAppEvent } from "../services/firebase.service";
var AnswerReveal = function (_a) {
    var answerCard = _a.answerCard;
    if (!answerCard)
        return null;
    var trigger = _jsx(Button, __assign({ onClick: function () { return logAppEvent('give_up_button'); } }, { children: "I give up" }), void 0);
    return _jsx(CardModal, { card: answerCard, trigger: trigger }, void 0);
};
export default AnswerReveal;
